import { useContext } from 'react';
import { BreakpointContext } from '../components/layout/BreakpointProvider';

export const useCurrentBreakpoint = () => {
    const currentBreakpoint = useContext(BreakpointContext);
    if (!currentBreakpoint) {
        throw new Error('useCurrentBreakpoint must be used within a BreakpointProvider');
    }

    return currentBreakpoint;
};
